<div class="w-full bg-white px-4 md:px-8" *ngIf="coleccionista$ | async as coleccionista">

    <!-- Header -->
    <div class="flex flex-col md:flex-row  justify-between items-center py-3 border-b">

        <!-- Title -->
        <div class="flex flex-row items-start md:items-center w-full">
            
            <div class="flex-1 flex flex-col md:flex-row justify-between">
                <div class="flex items-start md:items-center gap-2">
                        <arrow-back></arrow-back>
                    <div>
                        <div class="text-2xl font-extrabold leading-7 tracking-tight sm:leading-10 md:text-4xl">{{coleccionista.coleccionista.codigoColeccionista}} {{coleccionista.coleccionista.nombre}}</div>
                    </div>
                </div>
                <div class="flex gap-0 md:gap-2 justify-center md:items-end mt-2 md:mt-0">
                    <div
                        class="flex items-center justify-center w-auto max-w-56 px-4 rounded-full h-[30px] text-sm font-bold text-nowrap scale-95 md:scale-100"
                        [ngStyle]="{
                            'background-color': coleccionista.coleccionista.coleccion.valor1, 
                            'color':coleccionista.coleccionista.coleccion.valor2

                        }"
                    >
                        {{ coleccionista.coleccionista.coleccion.descripcion }}
                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="flex flex-col md:flex-row gap-10 py-4 h-auto md:h-56">
        <!-- Documento de Identidad -->
        <documento-identidad-coleccionista
            class="w-full md:w-3/12 max-h-full hidden md:block"
            [coleccionistaUuid]="coleccionista.coleccionista.coleccionistaUuid"
            [identificacionColeccionista]="coleccionista.blobURL">
        </documento-identidad-coleccionista>

        <documento-identidad-coleccionista *ngIf="coleccionista.blobURL"
            class="w-full md:w-3/12 max-h-full block md:hidden"
            [coleccionistaUuid]="coleccionista.coleccionista.coleccionistaUuid"
            [identificacionColeccionista]="coleccionista.blobURL">
        </documento-identidad-coleccionista>

        <informacion-personal-coleccionista class="hidden md:flex-1 h-full md:grid items-stretch"
            [coleccionista]="coleccionista">
        </informacion-personal-coleccionista>

        <mat-accordion class="flex-1 md:hidden">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                <mat-panel-title>Información Personal</mat-panel-title>
                </mat-expansion-panel-header>
                    <informacion-personal-coleccionista class="flex-1 h-full grid items-stretch"
                        [coleccionista]="coleccionista">
                    </informacion-personal-coleccionista>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab label="Bienes Registrados">
            
            <div class="flex justify-end w-full px-4">
                <button (click)="registrarBienCultural(coleccionista)"
                    class="ml-0 md:ml-4 w-full md:w-auto"
                    mat-flat-button
                    [color]="'primary'">
                    <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                    <span class="ml-2 mr-1">Registrar Nuevo Bien</span>
                </button>
            </div>

            <lista-bienes [dataSource]="bienesCulturales$ | async"></lista-bienes>
        </mat-tab>
        <mat-tab label="Actividad">
            @if (this.actividadColeccionista$ | async; as actividades ) {
                <ng-container >
                    <actividad-reciente [ActividadReciente]="actividades" class="px-4"></actividad-reciente>
                </ng-container>
            }
        </mat-tab>
    </mat-tab-group>
    
</div>